export function detectIntent(question) {
  const lower = question.toLowerCase();

  if (lower.includes("ford") && lower.match(/(modelle|camper|zeige mir|alle)/)) {
    return "list_models_ford";
  }

  if (lower.includes("volkswagen") && lower.match(/(modelle|camper|zeige mir|alle)/)) {
    return "list_models_volkswagen";
  }

  if (lower.includes("vw") && lower.match(/(modelle|camper|zeige mir|alle)/)) {
    return "list_models_volkswagen";
  }

  if (lower.includes("mercedes-benz") && lower.match(/(modelle|camper|zeige mir|alle)/)) {
    return "list_models_mercedes-benz";
  }

  if (lower.match(/(5|fünf).*schlaf/)) {
    return "filter_sleeping";
  }

  if (lower.includes("familie") || lower.includes("kinder")) {
    return "family_friendly";
  }

  if (lower.includes("schlaf") || lower.includes("schlaf")) {
    return "filter_sleeping";
  }

  return "default";
}

export function extractContextFromDescription(description, intent, wordRadius = 4) {
	let keyword = "";
	if(intent == "filter_sleeping")
		keyword = "Schlafplätze";
	if(intent == "list_models_ford")
		keyword = "Ford";
	if(intent == "list_models_volkswagen")
		keyword = "Volkswagen";
	if(intent == "list_models_mercedes_benz")
		keyword = "Mercedes-Benz";
	
	
  if (!description || !keyword) return "";

  const words = description.split(/\s+/);
  const lowerWords = words.map(w => w.toLowerCase());
  const index = lowerWords.findIndex(w => w.includes(keyword.toLowerCase()));

  if (index === -1) return "";

  const start = Math.max(0, index - wordRadius);
  const end = Math.min(words.length, index + wordRadius + 1);

  const excerpt = words.slice(start, end).join(" ");
  return `...${excerpt}...`;
}


export function getIntroText(intent) {
  const intros = {
    list_models_ford: [
      "Ford? Klar – hier sind alle verfügbaren Modelle für dich:",
      "Alles klar – das sind die aktuellen Ford-Modelle:",
      "Na dann – hier kommt die Ford-Übersicht!"
    ],
    list_models_volkswagen: [
      "Volkswagen? Klar – hier sind alle verfügbaren Modelle für dich:",
      "Alles klar – das sind die aktuellen Volkswagen-Modelle:",
      "Na dann – hier kommt die Volkswagen-Übersicht!"
    ],
    list_models_mercedes_benz: [
      "Mercedes-Benz? Klar – hier sind alle verfügbaren Modelle für dich:",
      "Alles klar – das sind die aktuellen Mercedes-Benz-Modelle:",
      "Na dann – hier kommt die Mercedes-Benz-Übersicht!"
    ],
    filter_sleeping: [
      "Schlafplätze gesucht? Diese Fahrzeuge bieten mindestens fünf davon:",
      "Perfekt für Camper: Diese Modelle haben mindestens 5 Schlafplätze.",
      "Hier sind Fahrzeuge, in denen wirklich jeder gut schlafen kann:"
    ],
    family_friendly: [
      "Familientauglich und bequem – hier sind passende Fahrzeuge für dich:",
      "Mit Kindern unterwegs? Diese Fahrzeuge bieten viel Platz und Komfort:",
      "Für kleine und große Familien: Diese Modelle passen gut."
    ],
    default: [
      "Hier ist, was ich gefunden habe:",
      "Das könnte dich interessieren:",
      "Hier die Ergebnisse deiner Anfrage:"
    ]
  };

  const options = intros[intent] || intros.default;
  return options[Math.floor(Math.random() * options.length)];
}